module.exports = __webpack_public_path__ + "images/rimbaud-03dc16a1f7955f21095d1b3a4c72adf8.jpg";